/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMioDTO } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ServiziIMieiServiziServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista dei servizi attivi che competono al caller.
     * Audience: OP_SCUOLA / OP_CENTRO_COTTURA (servizi assegnati via UserServizio, con ruolo_servizio) / OP_COMUNE (servizi dei propri comuni) / SUPERADMIN (tutti, compresi i non ancora avviati, per l\&#39;anteprima). Gli scaduti sono esclusi per tutti. Lista non paginata, ordinata per codice bando ASC, data_inizio DESC.
     * @endpoint get /api/v1/servizi/me
*/
    listServiziMiei(extraHttpRequestParams?: any): Observable<Array<ServizioMioDTO>>;

}
